import type { Meeting } from '@/types/greenroom/meeting.types';
import { Get } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

export function GetGreenroomMeetingData(sessionUuid: string): Promise<Meeting | null> {
  return Get({
    host: GREENROOM_HOST,
    path: `/v2/greenroom/events/get-session-by-uuid/${sessionUuid}`,
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    // Note: do not use cache, we need to make sure we always fetch latest data so we don't
    // accidentally send stale updates to greeenroom shot feeds
  });
}
